import {
  actionTypes,
  AppActionTypes,
  AdminFetchUsersListSuccessAction,
  AdminToggleUserRoleSuccessAction,
  AdminFetchAllRolesListSuccessAction,
  AdminToggleUserLocationSuccessAction,
  AdminFetchAllLocationsListSuccessAction
} from './actions';

import { User } from 'src/lib/interfaces/User.interface'
import { Location } from 'src/lib/interfaces/Location.interface'
import { UserAuthority } from 'src/lib/interfaces/UserAuthority.interface'

const findIndex = require('lodash/findIndex')

export interface AdminState {
  readonly users?: User[]
  readonly isFetchingUsers: boolean
  readonly allLocations?: Location[]
  readonly allRoles?: UserAuthority[]
  readonly isFetchingAllRoles: boolean
  readonly isFetchingAllLocations: boolean
}

export const initialState: AdminState = {
  users: undefined,
  allRoles: undefined,
  isFetchingUsers: false,
  allLocations: undefined,
  isFetchingAllRoles: false,
  isFetchingAllLocations: false
}

export function reducer(state: AdminState = initialState, action: AppActionTypes): AdminState {
  switch (action.type) {
    case actionTypes.ADMIN_FETCH_USERS_LIST:
      return {
        ...state,
        isFetchingUsers: true
      }

    case actionTypes.ADMIN_FETCH_USERS_LIST_FAILED:
      return {
        ...state,
        isFetchingUsers: false
      }

    case actionTypes.ADMIN_FETCH_USERS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingUsers: false,
        users: (action as AdminFetchUsersListSuccessAction).payload.users
      }

    case actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST:
      return {
        ...state,
        isFetchingAllLocations: true
      }

    case actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST_FAILED:
      return {
        ...state,
        isFetchingAllLocations: false
      }

    case actionTypes.ADMIN_FETCH_ALL_LOCATIONS_LIST_SUCCESS: {
      const successAction = action as AdminFetchAllLocationsListSuccessAction

      return {
        ...state,
        isFetchingAllLocations: false,
        allLocations: successAction.payload.locations
      }
    }

    case actionTypes.ADMIN_FETCH_ALL_ROLES_LIST:
      return {
        ...state,
        isFetchingAllRoles: true
      }

    case actionTypes.ADMIN_FETCH_ALL_ROLES_LIST_FAILED:
      return {
        ...state,
        isFetchingAllRoles: false
      }

    case actionTypes.ADMIN_FETCH_ALL_ROLES_LIST_SUCCESS: {
      const successAction = action as AdminFetchAllRolesListSuccessAction
      return {
        ...state,
        isFetchingAllRoles: false,
        allRoles: successAction.payload.roles
      }
    }

    case actionTypes.ADMIN_TOGGLE_USER_ROLE_SUCCESS: {
      const successAction = action as AdminToggleUserRoleSuccessAction
      const updatedUser = successAction.payload.user

      const users = [ ...(state.users || []) ]
      const updatedUserIndex = findIndex(users, { id: updatedUser.id })
      if (updatedUserIndex >= 0) {
        users[updatedUserIndex] = updatedUser
        return {
          ...state,
          users
        }
      }

      return state
    }

    case actionTypes.ADMIN_TOGGLE_USER_LOCATION_SUCCESS: {
      const successAction = action as AdminToggleUserLocationSuccessAction
      const updatedUser = successAction.payload.user

      const users = [ ...(state.users || []) ]
      const updatedUserIndex = findIndex(users, { id: updatedUser.id })
      if (updatedUserIndex >= 0) {
        users[updatedUserIndex] = updatedUser
        return {
          ...state,
          users
        }
      }

      return state
    }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/admin/reducer.ts